import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';
import {IEditCountry} from '../../../../shared/services/configuration/countries/dtos/edit-country';
import {useNavigate} from 'react-router-dom';

export const useEditCountry = () => {
  const navigate = useNavigate();
  return useMutation(
    async (payload: IEditCountry) => {
      return await countriesService.editCountry(payload);
    },
    {
      onSuccess: () => navigate('/configuration/countries'),
    },
  );
};
